// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentHolder_z4AkV {
  position: relative;
  overflow: hidden;
}

.header_EadcN {
  padding: var( --size-padLarge );
}

.titleBar_TladG {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.5s;
}

.viewerHolder_F4vux {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  container-type: size;
}

.viewerHolder_F4vux > :nth-child(2) {
  width: 100%;
  height: 100%;
}

.hasCycledView_IwTo8 {
  background-color: rgba(0,0,0, 0.5);
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%,-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--size-padXLarge);
  opacity: 0;
  border-radius: var(--size-padXLarge);
}

.hasCycledIcon_yV094 {
  color: white;
  font-size: calc(min(20cqh, 20cqw));
}

.hasCycled_dk8DJ {
  animation: fadeInOut_azcwk 1s linear 1 forwards;
}

.carouselButton_fpOKj {
  height: 100%;
  width: 20cqw;
  position: absolute;
  display: grid;
  align-items: center;
  container-type: inline-size;
}

.iconHolder_ncVcZ {
  background: rgba(0,0,0,0.5);
  width: 40px;
  height: 40px;
  border-radius: 40px;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carouselButtonPrevious_OPeyx > .iconHolder_ncVcZ {
  margin-left: 50cqw;
}

.carouselButtonNext_EXYmW > .iconHolder_ncVcZ {
  margin-right: 50cqw;
}

.iconHolder_ncVcZ > i {
  color: white;
  transition: opacity 0.5s;
}

.carouselButton_fpOKj:hover {
  cursor: pointer;
}

.carouselButton_fpOKj:hover > .iconHolder_ncVcZ {
  opacity: 1;
}

.carouselButtonPrevious_OPeyx {
  top: 0;
  left: 0;
  justify-content: flex-start;
  padding-left: 20px;
}

.carouselButtonNext_EXYmW {
  top: 0;
  right: 0;
  justify-content: flex-end;
  padding-right: 20px;
}

.pagination_u2J_K {
  color: white;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: var(--size-padSmall) var(--size-padLarge);
  background: black;
  opacity: 0;
  transition: opacity 0.5s;
}

.visible_PfZ3G {
  opacity: 1;
}

.invisible_x8Ga0 {
  opacity: 0;
}


@keyframes fadeInOut_azcwk {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/components/rsrcGallery/SelectedDialog.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,+CAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kDAAkD;EAClD,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".contentHolder {\n  position: relative;\n  overflow: hidden;\n}\n\n.header {\n  padding: var( --size-padLarge );\n}\n\n.titleBar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n\n.viewerHolder {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  container-type: size;\n}\n\n.viewerHolder > :nth-child(2) {\n  width: 100%;\n  height: 100%;\n}\n\n.hasCycledView {\n  background-color: rgba(0,0,0, 0.5);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 999;\n  transform: translate(-50%,-50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--size-padXLarge);\n  opacity: 0;\n  border-radius: var(--size-padXLarge);\n}\n\n.hasCycledIcon {\n  color: white;\n  font-size: calc(min(20cqh, 20cqw));\n}\n\n.hasCycled {\n  animation: fadeInOut 1s linear 1 forwards;\n}\n\n.carouselButton {\n  height: 100%;\n  width: 20cqw;\n  position: absolute;\n  display: grid;\n  align-items: center;\n  container-type: inline-size;\n}\n\n.iconHolder {\n  background: rgba(0,0,0,0.5);\n  width: 40px;\n  height: 40px;\n  border-radius: 40px;\n  opacity: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carouselButtonPrevious > .iconHolder {\n  margin-left: 50cqw;\n}\n\n.carouselButtonNext > .iconHolder {\n  margin-right: 50cqw;\n}\n\n.iconHolder > i {\n  color: white;\n  transition: opacity 0.5s;\n}\n\n.carouselButton:hover {\n  cursor: pointer;\n}\n\n.carouselButton:hover > .iconHolder {\n  opacity: 1;\n}\n\n.carouselButtonPrevious {\n  top: 0;\n  left: 0;\n  justify-content: flex-start;\n  padding-left: 20px;\n}\n\n.carouselButtonNext {\n  top: 0;\n  right: 0;\n  justify-content: flex-end;\n  padding-right: 20px;\n}\n\n.pagination {\n  color: white;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: var(--size-padSmall) var(--size-padLarge);\n  background: black;\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n\n@keyframes fadeInOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentHolder": `contentHolder_z4AkV`,
	"header": `header_EadcN`,
	"titleBar": `titleBar_TladG`,
	"viewerHolder": `viewerHolder_F4vux`,
	"hasCycledView": `hasCycledView_IwTo8`,
	"hasCycledIcon": `hasCycledIcon_yV094`,
	"hasCycled": `hasCycled_dk8DJ`,
	"fadeInOut": `fadeInOut_azcwk`,
	"carouselButton": `carouselButton_fpOKj`,
	"iconHolder": `iconHolder_ncVcZ`,
	"carouselButtonPrevious": `carouselButtonPrevious_OPeyx`,
	"carouselButtonNext": `carouselButtonNext_EXYmW`,
	"pagination": `pagination_u2J_K`,
	"visible": `visible_PfZ3G`,
	"invisible": `invisible_x8Ga0`
};
export default ___CSS_LOADER_EXPORT___;
